import { Link } from "react-router-dom";
import { Calendar, Ticket as TicketIcon, Trophy } from "lucide-react";

const FALLBACK_IMAGE =
    "https://images.unsplash.com/photo-1715520928476-cd350276d96e?w=1200&q=80&auto=format&fit=crop";

function formatDate(s) {
    try {
        const d = new Date(s);
        return d.toLocaleDateString("es-PE", { day: "2-digit", month: "short", year: "numeric" });
    } catch (_e) {
        return s;
    }
}

export default function RaffleCard({ raffle }) {
    const backendUrl = process.env.REACT_APP_BACKEND_URL;
    const rawImg = raffle.image_url || FALLBACK_IMAGE;
    const img = rawImg.startsWith("/api/") ? `${backendUrl}${rawImg}` : rawImg;
    const sold = raffle.tickets_sold || 0;
    const pct = Math.min(100, Math.round((sold / raffle.total_tickets) * 100));

    return (
        <Link
            to={`/rifas/${raffle.id}`}
            className="brut-card block group transition-transform hover:-translate-y-1 hover:-translate-x-1 hover:shadow-brut-lg"
            data-testid={`raffle-card-${raffle.id}`}
        >
            <div className="aspect-[4/3] border-b-2 border-ink overflow-hidden bg-muted_bg relative">
                <img src={img} alt={raffle.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" />
                <div className="absolute top-3 left-3 bg-coral border-2 border-ink shadow-brut-sm px-2 py-1 text-[10px] uppercase tracking-widest font-black text-white">
                    {raffle.status === "drawn" ? "Sorteada" : "Activa"}
                </div>
            </div>
            <div className="p-5 space-y-3">
                <h3 className="font-display font-black text-xl leading-tight line-clamp-2">{raffle.title}</h3>
                <div className="flex items-center gap-1 text-sm font-bold uppercase tracking-wider">
                    <Trophy className="w-4 h-4 text-coral" strokeWidth={3} />
                    <span className="line-clamp-1">{raffle.prize}</span>
                </div>
                <div className="grid grid-cols-2 gap-2 pt-2 border-t-2 border-dashed border-ink">
                    <div>
                        <div className="text-[10px] uppercase tracking-widest font-bold opacity-60">Precio</div>
                        <div className="font-display font-black text-lg">S/ {raffle.price_per_ticket.toFixed(2)}</div>
                    </div>
                    <div>
                        <div className="text-[10px] uppercase tracking-widest font-bold opacity-60">Sorteo</div>
                        <div className="font-bold text-sm flex items-center gap-1">
                            <Calendar className="w-3 h-3" strokeWidth={3} />
                            {formatDate(raffle.draw_date)}
                        </div>
                    </div>
                </div>
                <div>
                    <div className="flex justify-between text-[10px] uppercase tracking-widest font-bold mb-1">
                        <span><TicketIcon className="w-3 h-3 inline mr-1" strokeWidth={3} />{sold}/{raffle.total_tickets} vendidos</span>
                        <span>{pct}%</span>
                    </div>
                    <div className="w-full h-3 border-2 border-ink bg-white overflow-hidden">
                        <div className="h-full bg-mint" style={{ width: `${pct}%` }} />
                    </div>
                </div>
            </div>
        </Link>
    );
}
